import { AMC_VARIANT, useAdaptableMenuCardsVariant } from './use-adaptable-menu-cards-variant';

export const useEnableAdaptableMenuCards = () => {
  const variant = useAdaptableMenuCardsVariant();

  return variant !== AMC_VARIANT.DISABLED;
};
